// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__1aOQm","modal":"modal_modal__2Aaxc"};